/* eslint-disable */

import '../vendor/owl-carousel';

(function() {
  'use strict';

  // require("vendor/owl-carousel");

  $('.home-carousel').owlCarousel({
    navigation: true, // Show next and prev buttons
    slideSpeed: 300,
    paginationSpeed: 400,
    touchDrag: true,
    singleItem: true,
    autoPlay: true,
    autoPlayInterval: 1000,
  });

  (function() {
    homecarouselHeight();
  })();

  function homecarouselHeight() {
    $('.home-carousel .owl-item').css('height', 'auto');
    var outHeight = $('.home-carousel .owl-wrapper-outer').height() + 10;
    $('.home-carousel .owl-item').each(function() {
      $(this).css('height', outHeight);
    });
  }

  $(window).on('reCalcHomecarouselHeight resize', function() {
    homecarouselHeight();
  });

  $('.polaroid').owlCarousel({
    navigation: true, // Show next and prev buttons
    slideSpeed: 300,
    pagination: false,
    paginationSpeed: 400,
    touchDrag: true,
    singleItem: true,
  });
})();
